import WaveformVisualizer from './WaveformVisualizer';

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <div className="hero-title">
          <span className="title-prefix slow-pulse">immersive</span>
          <h1 className="glow-text">DRONE</h1>
          <span className="title-suffix">soundscapes</span>
        </div>
        
        <p className="hero-tagline">
          sustained tones · evolving textures · infinite horizons
        </p>
        
        <div className="hero-visualizer">
          <WaveformVisualizer />
        </div>
        
        <a href="#listen" className="scroll-indicator drift">
          <span>enter the sound</span>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
            <path d="M12 5v14M5 12l7 7 7-7"/>
          </svg>
        </a>
      </div>
    </section>
  );
}
